<div class="loading-spinner" *ngIf="loading">
  <mat-spinner [diameter]="40" strokeWidth="3"></mat-spinner>
</div>
<div *ngIf="!loading && genehmigungDetail">
  <div class="desc-box">
    <div class="add-row">
      <ng-container *ngIf="genehmigungDetail.genehmStatus.key!==''">
        <span class="fixed-col">Genehmiger: {{ genehmigungDetail.genehmBenutzer }}</span>
        <span class="fixed-col">Status: {{ genehmigungDetail.genehmStatus.value }}</span>
        <div class="button-col">
          <a class="is-link" (click)="navigateToPeziGenehmigung()">Genehmigung im NV-Cockpit öffnen</a>
        </div>
      </ng-container>
      <ng-container *ngIf="genehmigungDetail.genehmStatus.key===''">
        <span class="fixed-col">{{ genehmigungDetail.genehmStatus.value }}</span>
      </ng-container>
    </div>
  </div>
  <div class="desc-box" *ngIf="genehmigungDetail?.genehmigungFiles?.length>0">
    <div class="add-row"
         *ngFor="let dokument of genehmigungDetail.genehmigungFiles; let i = index">
      <span class="fixed-col gray-text">{{ getPreText(i) }}</span>
      <span class="fixed-col">
                <div class="icon-text">
                  <span class="check-msg">{{ dokument.name }}</span>
                  <mat-icon [ngClass]="[getStatusIconClass(dokument)]">{{ getStatusIcon(dokument) }}</mat-icon>
                </div>
              </span>
      <div class="button-col" *ngIf="dokument.missing === true">
        <button mat-raised-button class="mat-gray-bg button-right-margin flex-button"
                (click)="showGenehmigungFileDialog(dokument)">
          Unterschreiben
        </button>
        <mat-icon class="info-icon"
                  matTooltip="Öffnet Dialog zur Bearbeitung benötigter Dokumente"
                  matTooltipPosition="right"
                  matTooltipClass="tooltip-multiline">info_outline
        </mat-icon>
      </div>
    </div>
  </div>
  <div class="desc-box" *ngIf="genehmigungDetail?.genehmigungInfoUrl?.length>0">
    <div class="add-row"
         *ngFor="let link of genehmigungDetail.genehmigungInfoUrl">
      <span class="fixed-col"></span>
      <span class="fixed-col"></span>
      <span class="fixed-col">
          <a class="is-link" target="_blank" rel="noopener noreferrer" href="{{link.value}}">{{ link.key }}</a>
      </span>
    </div>
  </div>
</div>

